import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { BaseButton } from './baseButton';


@Component({
  selector: 'app-tooltip-button',
  templateUrl: './tooltip-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TooltipButtonComponent extends BaseButton implements OnInit, OnChanges {

  @Input() placement = 'left';

  constructor() {
    super();
  }

  ngOnInit() {
    if (!this.btnStyle) {
      this.btnStyle = 'link';
    }

    if (!this.icon) {
      this.icon = 'info';
    }

    super.onInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    super.onChanges();
  }

}
